<template>
  <div data-fixer-width-wrapper>
    <div class="data-grid-table" data-fixer-container>
      <div class="bootstrap-table">
        <div class="fixed-table-toolbar">
          <div class="bs-bars pull-left">
            <!--<div data-v-6c6f8ad3="" role="group" class="btn-group toolbar">-->
            <!--<button data-v-6c6f8ad3="" type="button" class="btn btn-success">-->
            <!--<i data-v-6c6f8ad3="" aria-hidden="true" class="icon wb-plus"></i>-->
            <!--</button>-->
            <!--</div>-->
            <div data-v-6c6f8ad3="" role="group" class="btn-group toolbar" style="margin-left: 5px;">
              <button data-v-6c6f8ad3="" type="button" class="btn btn-outline btn-default z-index">
                <i data-v-6c6f8ad3="" aria-hidden="true" class="icon fa-database"></i>
                <span data-v-6c6f8ad3="" class="badge badge-pill badge-danger up">{{ itemsCount }}</span>
              </button>
            </div>
          </div>
          <div class="columns columns-right btn-group pull-right">
            <button @click="_refresh" class="btn btn-default btn-outline" type="button" name="refresh" aria-label="refresh" title="Refresh">
              <i class="glyphicon wb-refresh"></i>
            </button>
          </div>
          <div class="pull-right search">
            <input
              v-model="searchText"
              class="form-control input-outline"
              type="text"
              placeholder=""
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="renderBlock">
      <div class="card-deck">
        <div v-for="item in data" class="col-md-3">
          <div class="card">
            <img v-on:click="_toEditor(item)" class="card-img-top w-full" :src="item[imageKey]"
                 alt="Card image cap">
            <div class="card-block">
              <template v-for="columnDefinition in gridColumns"
                        v-if="item[columnDefinition.field] && item[columnDefinition.field] !== ' ' && columnDefinition.fieldType !== 'Document'">
                <h4 class="card-title">{{ columnDefinition.title }}</h4>
                <p v-on:click="_toEditor(item)" class="card-text">{{ item[columnDefinition.field] }}</p>
                <!--<p class="card-text hidden-md-down">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat-->
                <!--nulla-->
                <!--pariatur.</p>-->
                <!--<p class="card-text">-->
                <!--<small class="text-muted">Last updated 3 mins ago</small>-->
                <!--</p>-->
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="preloader" class="preloader-wrapper">
      <div class="loader loader-grill"></div>
    </div>
  </div>
</template>

<script>
import ResourceGetter from '../../../model/resource/getter/resource-getter'

export default {
  name:  'GalleryGenerator',
  props: [
    'definitionResponse',
    'pagination'
  ],
  data () {
    return {
      data:        [],
      gridColumns: [],
      images:      [],
      renderBlock: false,
      resource:    undefined,
      imageKey:    undefined,
      searchText:  null,
      itemsCount:  0,
      offset:      1,

      searchTimer: null,
      refresh:     false
    }
  },

  watch: {
    'pagination': function (offset) {
      if (this.refresh) {
        return
      }

      this.offset = offset

      this._loadData('append')
    },
    'searchText': function () {
      if (this.refresh) {
        return
      }

      clearTimeout(this.searchTimer)

      this.searchTimer = setTimeout(() => {
        this.refresh = true
        this.offset  = 1
        this.$parent._resetOffset()
        this._loadData()
        window.scrollTo(0, 0)
      }, 500)
    }
  },

  created () {
    this.resource       = ResourceGetter.get(this.definitionResponse.data[0].ViewName)
    let listColumnsData = this.definitionResponse.data[0].List

    for (let i = 0; i < listColumnsData.length; i++) {
      let item = listColumnsData[i]

      let column = {
        field:     item.Field,
        title:     this.$translate.text(item.Label),
        fieldType: item.FieldType,
        dataType:  item.DataType
      }

      if (item.FieldType === 'Autocomplete' || item.FieldType === 'DropDown') {
        column.field = 'ST' + item.Field
      }

      if (item.hasOwnProperty('Interpretation') && item.Interpretation === 'Url') {
        this.imageKey = item.Field
        continue
      }

      this.gridColumns.push(column)
    }
  },

  mounted () {
    this._loadData()
    this._initFixer()
  },

  methods: {

    /**
     *
     * @private
     */
    _loadData (method = 'init') {
      let args = {}

      $(this.$refs.preloader).show()

      if (this.offset) {
        args.offset = this.offset
      }

      if (this.searchText) {
        args.searchText = this.searchText
      }

      this.resource.find(args)
          .then(response => {
            if (method === 'append') {
              for (let i = 0; i < response.data.length; i++) {
                this.data.push(response.data[i])
              }
            }
            else {
              this.data = response.data
            }

            if (response.data.length && response.data[0].hasOwnProperty('rows_count')) {
              this.itemsCount = response.data[0].rows_count
            }
            else {
              if (this.offset === 1) {
                this.itemsCount = 0
              }
            }

            this.renderBlock = true
            this.refresh     = false
            $(this.$refs.preloader).hide()
          })
          .catch(error => {
            this.handleApiError(error)
          })
    },

    /**
     *
     * @private
     */
    _refresh () {
      this.refresh    = true
      this.searchText = null
      this.offset     = 1
      this.$parent._resetOffset()

      window.scrollTo(0, 0)

      this._loadData()
    },

    /**
     *
     * @private
     */
    _prepareEditorProps (rowData = {}) {
      let isReadOnly = false

      if (this.definitionResponse.data[0].hasOwnProperty('IsReadOnly') && this.definitionResponse.data[0].IsReadOnly === 'true') {
        isReadOnly = true
      }
      return {
        id:            rowData.hasOwnProperty('ID') ? rowData.id : null,
        page:          this.$route.params.page,
        sourceType:    this.definitionResponse.data[0].ViewName,
        businessRules: {
          newrec: this.definitionResponse.data[0].NewRec,
          valrec: this.definitionResponse.data[0].ValRec,
          calrec: this.definitionResponse.data[0].CalRec,
          delrec: this.definitionResponse.data[0].DelRec
        },
        defaults:      rowData,
        formFields:    this.definitionResponse.data[0].Editor,
        idStructure:   this.$route.params.idStructure,
        h1:            this.definitionResponse.data[0].DictionaryKeyCode,
        isReadOnly:    isReadOnly
      }
    },

    /**
     *
     * @param lastId
     */
    _saveGridState (lastId = null) {
      let params = {
        lastId:          lastId,
        lastPage:        this.innerPageType,
        idStructure:     this.$route.params.idStructure,
        lastData:        this.data,
        lastOffset:      this.offset,
        lastTopPosition: this.topPosition,
        searchedText:    this.searchedText,
        lastCount:       this.count,
        isLastOffset:    this.isLastOffset,
        lastResource:    this.resource
      }

      this.$store.commit('setGridData', params)
    },

    /**
     *
     * @param rowData
     * @private
     */
    _toEditor (rowData) {
      // this._saveGridState(rowData.id)

      this.$router.push({ name: 'PageDynamicEditor', params: this._prepareEditorProps(rowData) })
    },

    /**
     *
     * @private
     */
    _initFixer: function () {
      let ff = ff || fixer()
      ff.init()
    }
  }
}
</script>
